import axios from 'axios';
import React, { useState, useEffect, useContext } from 'react';

import SelectComponent from '../common/select';
import OptionComponent from '../common/option';

import { CustomizeContext } from '../contexts/customize';

const client = axios.create({
  baseURL: process.env.REACT_APP_API_URL + '/get_cuffs'
});

const productId = document.getElementById('mtm-customize').dataset.productId;

const MtmCuffs = () => {
  const [list, setList] = useState([]);

  const { customizes } = useContext(CustomizeContext);

  useEffect(() => {
    const getList = async () => {
      const response = await client.get(
        '?product_id=' +
          productId +
          '&neck_id=' +
          customizes.collar.id +
          '&neck_value=' +
          customizes.collar.value
      );
      setList(response.data.result);
    };
    getList();
  }, [customizes.collar.id, customizes.collar.value]);

  if (!list) return 'No cuffs!';

  return (
    <div
      className="mtm-item__wrapper"
      id="mtm-cuffs"
      data-neck-id={customizes.collar.id}
      data-neck-value={customizes.collar.value}
    >
      <h3 className="mtm-item__title">CUFFS</h3>
      <div className="mtm-item__selects row row-cols-2 row-cols-md-4">
        {list.map((item, ind) => (
          <SelectComponent
            item={item}
            ind={ind}
            name="cuffs"
            key={`${item.value}-${ind}`}
            col={3}
            colSp={6}
          />
        ))}
      </div>
      {/* KS-444 2408 CuffsType カフスタイプ 非表示
      <div className="mtm-item__options" id="mtm-cuffs__option">
        {Object.keys(list).map((item, ind) => {
          return (
            <div
              className="options-item mtm-item__selects"
              data-cuffs={list[item].value}
              key={`cuffs-sel-${ind}`}
            >
              {list[item].cuffs_type.map((cleric, ind) => {
                return (
                  <OptionComponent
                    cleric={cleric}
                    ind={ind}
                    parent="cuffs"
                    name="cuffs_type"
                    key={`cuffs-${ind}`}
                  />
                );
              })}
            </div>
          );
        })}
      </div> */}
    </div>
  );
};

export default MtmCuffs;
